import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../data-access';
import { IStatesApiClient } from './i-states-api.client';
import { StatesApiClient } from './states-api.client';
import { StatesInMemoryApiClient } from './states.api.inmemory.client';

@Injectable({
  providedIn: 'root'
})
export class StatesApiClientProvider extends ApiClientProvider<IStatesApiClient> {
  constructor(
    private client: StatesApiClient,
    private inMemoryClient: StatesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IStatesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IStatesApiClient {
    return this.client;
  }
}
